(function () {
  if (customElements.get('tech-carousel-block')) return;

  class TechCarouselBlock extends HTMLElement {
    connectedCallback() {
      var self = this;
      var track = this.querySelector('[data-tc-track]');
      var prevBtn = this.querySelector('[data-tc-prev]');
      var nextBtn = this.querySelector('[data-tc-next]');

      if (!track || !prevBtn || !nextBtn) return;

      this._track = track;
      this._prevBtn = prevBtn;
      this._nextBtn = nextBtn;
      this._timer = null;

      var cardStep = function () {
        var card = track.querySelector('.tech-carousel__card');
        if (!card) return 0;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      var atEnd = function () {
        return track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      };

      var updateArrows = function () {
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = atEnd();
      };

      var goNext = function () {
        if (atEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: cardStep(), behavior: 'smooth' });
        }
      };

      var goPrev = function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      };

      var stopAutoplay = function () {
        if (self._timer) {
          clearInterval(self._timer);
          self._timer = null;
        }
      };

      var startAutoplay = function () {
        if (self.dataset.autoplay !== 'true') return;
        stopAutoplay();
        var seconds = parseFloat(self.dataset.autoplaySpeed) || 4;
        self._timer = setInterval(goNext, seconds * 1000);
      };

      prevBtn.addEventListener('click', function () {
        goPrev();
        startAutoplay();
      });

      nextBtn.addEventListener('click', function () {
        goNext();
        startAutoplay();
      });

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);

      if (self.dataset.pauseOnHover === 'true') {
        self.addEventListener('mouseenter', stopAutoplay);
        self.addEventListener('mouseleave', startAutoplay);
        self.addEventListener('touchstart', stopAutoplay, { passive: true });
      }

      updateArrows();
      startAutoplay();

      this._stopAutoplay = stopAutoplay;
    }

    disconnectedCallback() {
      if (this._stopAutoplay) this._stopAutoplay();
    }
  }

  customElements.define('tech-carousel-block', TechCarouselBlock);
})();
